import { Pattern, RegisterPattern } from "../../Pattern"

RegisterPattern(Pattern.ParsePatFile(`
*ANSI31,ANSI31
45, 0,0, 0,3.175
`))
